define.alias("shared/errors/api-not-found-error", "calendar/errors/api-not-found-error");